// extracted by mini-css-extract-plugin
module.exports = {"box":"PopupContentDynamic_box__ty_B0","button":"PopupContentDynamic_button__2-miP"};